import React, {useEffect, useState, useContext} from 'react';
import PieChart1 from './PieChart1';
import {useTranslation} from 'react-i18next';
import {Context} from '../../../../Helpers/Auth';
import Spinner from '../../../../components/Spinner';

function TableTop1({clientes}) {
    const {t} = useTranslation();
    const [isMobile, setIsMobile] = useState(false);
    const {isCard, openCards, formatarNumero} = useContext(Context);
   
    const [loading, setLoading] = useState(false);

    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="h-full">
            {isMobile || isCard ? (
                <div>
                    <div className="flex bg-gray-100 rounded-t-[8px] dark:bg-gray-600 flex-wrap items-center px-4 py-2">
                        <div className="relative w-full max-w-full flex-grow flex-1 ">
                            <h3 className="font-semibold text-base text-gray-900 dark:text-gray-50 ">{t('topCliente1Ano')}</h3>
                        </div>
                    </div>
                    {clientes?.map((dados, index) => (
                        <div key={index} className={`rounded-none h-full overflow-y-auto border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                            <h2 className="mb-0" id="headingOne">
                                <button
                                    className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                    type="button"
                                    data-te-collapse-init
                                    data-te-collapse-collapsed
                                    data-te-target={'#flush-collapseThree' + index}
                                    aria-expanded="false"
                                    aria-controls="flush-collapseThree">
                                    <div className="flex flex-row">
                                        {index + 1} - {dados.cliente}
                                    </div>
                                    <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                        </svg>
                                    </span>
                                </button>
                            </h2>
                            <div
                                id={'flush-collapseThree' + index}
                                className={openCards ? 'visible' : '!visible hidden'}
                                data-te-collapse-item
                                aria-labelledby="flush-headingThree"
                                data-te-parent="#accordionFlushExample">
                                <div className="px-5 py-4">
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400  mr-2">{t('codigo')}:</div> {dados.codigo}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('cliente')}: </div> {dados.cliente}
                                    </div>
                                    <div className="text-gray-500 flex flex-row">
                                        <div className="font-medium text-gray-400 mr-2">{t('valor')}: </div> {formatarNumero(dados.valor)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {loading && (
                        <div className="flex flex-row mt-14 justify-center">
                            <>
                                <Spinner />
                            </>
                        </div>
                    )}
                </div>
            ) : (
                <div className=" rounded-[8px] w-full h-full   border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-gray-800 dark:bg-gray-800 sm:px-7.5 xl:pb-1">
                    <h4 className="mb-4 text-xl font-semibold text-black dark:text-white">{t('topCliente1Ano')}</h4>

                    <table className="flex flex-col">
                        <thead>
                            <tr className="grid grid-cols-3 dark:text-gray-100 rounded-[8px] bg-gray-100 dark:bg-gray-600 sm:grid-cols-5">
                                <th className="p-2.5 xl:p-2">
                                    <h5 className="text-sm font-medium uppercase xsm:text-base">{t('')}</h5>
                                </th>
                                <th className="p-2.5 text-center xl:p-2">
                                    <h5 className="text-sm font-medium uppercase xsm:text-base">{t('codigo')}</h5>
                                </th>
                                <th className="p-2.5 text-center xl:p-2">
                                    <h5 className="text-sm font-medium uppercase xsm:text-base">{t('cliente')}</h5>
                                </th>
                                <th className="hidden p-2.5 text-center sm:block xl:p-2">
                                    <h5 className="text-sm font-medium uppercase xsm:text-base">{t('valor')}</h5>
                                </th>
                            </tr>
                        </thead>
                        {clientes?.map((dados, index) => (
                            <tbody>
                                <tr className="grid grid-cols-3 overflow-y-auto border-b border-stroke dark:border-strokedark sm:grid-cols-5">
                                    <td className="flex items-center gap-3 px-2.5 xl:px-5">
                                        <p className="hidden text-black dark:text-white sm:block">{index + 1}</p>
                                    </td>

                                    <td className="flex items-center justify-center px-2.5 xl:px-5">
                                        <p className="text-black dark:text-white">{dados.codigo}</p>
                                    </td>

                                    <td className="flex items-center justify-center px-2.5 xl:px-5">
                                        <p className="text-black dark:text-white">{dados.cliente}</p>
                                    </td>

                                    <td className="hidden items-center justify-center px-2.5 sm:flex xl:px-5">
                                        <p className="px-2 font-semibold leading-tight text-green-700 bg-green-100 rounded-full dark:bg-green-700 dark:text-green-100">{formatarNumero(dados.valor)}</p>
                                    </td>
                                </tr>
                            </tbody>
                        ))}
                    </table>
                </div>
            )}
        </div>
    );
}

export default TableTop1;
